import { Cartable } from "../providers/cart.provider";

export class Product implements Cartable
{
  ProductId:        string;
  OriginalName:     string;
  Name:             string;
  ProductFamily:    string;
  Category:         string;
  ALIGAL:           string;
  NoMap:            string;
  WithMap:          string;
  Temperature:      string;
  LimitingFactors:  string;
  OxygenLevel:      string;
  TypeOfFilm:       string;
  AdditionalInfos:  string;
  Country:          string;
  Image:            string;
  Updated:          string;
  UpdatedBy:        string;
  Created:          string;
  CreatedBy:        string;
  Id:               string;
  DocumentId:       string;
  LineNumber:       string;
  Translation:      string;
  DisplayedInCountries: string[]|null;

  constructor(obj : any)
  {
    this.ProductId = obj.ProductId;
    this.Name = obj.Name;
    this.OriginalName = obj.Name;
    this.ProductFamily = obj.ProductFamily;
    this.Category = obj.Category;
    this.ALIGAL = obj.ALIGAL;
    this.NoMap = obj.NoMap;
    this.WithMap = obj.WithMap;
    this.Temperature = obj.Temperature;
    this.LimitingFactors = obj.LimitingFactors;
    this.OxygenLevel = obj.OxygenLevel;
    this.TypeOfFilm = obj.TypeOfFilm;
    this.AdditionalInfos = obj.AdditionalInfos;
    this.Country = obj.Country;
    this.Image = obj.Image;
    this.Updated = obj.Updated;
    this.UpdatedBy = obj.UpdatedBy;
    this.Created = obj.Created;
    this.CreatedBy = obj.CreatedBy;
    this.Id = obj.Id;
    this.DocumentId = obj.DocumentId;
    this.LineNumber = obj.LineNumber;
    this.Translation = obj.Translation;
    this.DisplayedInCountries = obj.DisplayedInCountries
  }

  getBusinessCode() { return this.ProductId }

}



// WEBPACK FOOTER //
// ./src/app/shared/models/product.ts